module.exports = __webpack_public_path__ + "img/premium-badge-gold.fc399f04.svg";